<div class="GroupMatrix">
  <div class="row">
    <div class="col-md-6">
      <document-group-matrix 
        *ngFor="let group of groups | evenodd:'odd';"  
        [group]="group"
        [newIndicatorDays]="newIndicatorDays">
      </document-group-matrix>
    </div>
    <div class="col-md-6">
      <document-group-matrix 
        *ngFor="let group of groups | evenodd:'even';"  
        [group]="group"
        [newIndicatorDays]="newIndicatorDays">
      </document-group-matrix>
    </div>
  </div>
</div>
